export default __webpack_public_path__ + "static/media/Q5_1.429237df.png";